// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"278":"147d1c9950ff22a9","596":"b520ec35a0373e14"}[chunkId] + ".js";
};